import { Button } from "@/shared/components/ui/button";
import { cn } from "@/shared/lib/utils";
import { CONTACT_SALES_URL } from "../constants";

type ContactSalesButtonProps = {
  className?: string;
};

export function ContactSalesButton({ className }: ContactSalesButtonProps) {
  return (
    <Button asChild variant="default" className={cn(className)}>
      <a href={CONTACT_SALES_URL} target="_blank" rel="noopener noreferrer">
        Contact Sales
      </a>
    </Button>
  );
}
